export default {
  "commerce-sector-1":                    "Agencia de Viajes",
  "commerce-sector-10":                   "Automóvil",
  "commerce-sector-12":                   "Autopistas",
  "commerce-sector-13":                   "Bar",
  "commerce-sector-14":                   "Bazares",
  "commerce-sector-15":                   "Bolsa",
  "commerce-sector-16":                   "Bricolaje y menaje de Hogar",
  "commerce-sector-17":                   "Cafeterías",
  "commerce-sector-18":                   "Cajeros",
  "commerce-sector-19":                   "Calzado",
  "commerce-sector-2":                    "Agencia de Viajes eCommerce",
  "commerce-sector-20":                   "Complementos",
  "commerce-sector-22":                   "Cuidado Infantil",
  "commerce-sector-23":                   "Deportes",
  "commerce-sector-25":                   "Donaciones",
  "commerce-sector-28":                   "Electrónica",
  "commerce-sector-30":                   "Estudios",
  "commerce-sector-32":                   "Fotografía",
  "commerce-sector-35":                   "Gasolineras",
  "commerce-sector-36":                   "Hogar",
  "commerce-sector-37":                   "Hoteles",
  "commerce-sector-38":                   "Hoteles - Premium",
  "commerce-sector-4":                    "Alimentación Grande",
  "commerce-sector-40":                   "Infantil",
  "commerce-sector-42":                   "Juguetes",
  "commerce-sector-43":                   "Loterías",
  "commerce-sector-44":                   "Lujo",
  "commerce-sector-45":                   "Mascotas",
  "commerce-sector-48":                   "Muebles",
  "commerce-sector-5":                    "Alimentación",
  "commerce-sector-50":                   "Ocio",
  "commerce-sector-51":                   "eCommerce",
  "commerce-sector-54":                   "Otros Comercios",
  "commerce-sector-59":                   "Parking",
  "commerce-sector-6":                    "Alimentación Pequeño",
  "commerce-sector-63":                   "Reparación",
  "commerce-sector-64":                   "Restaurantes",
  "commerce-sector-65":                   "Restaurantes - Fast Food",
  "commerce-sector-66":                   "Ropa",
  "commerce-sector-67":                   "Salud",
  "commerce-sector-68":                   "Salud - Belleza",
  "commerce-sector-69":                   "Salud - Deporte",
  "commerce-sector-7":                    "Alquiler Ropa",
  "commerce-sector-70":                   "Seguros",
  "commerce-sector-72":                   "Telefonía",
  "commerce-sector-75":                   "Transporte",
  "commerce-sector-76":                   "Transporte - Avión",
  "commerce-sector-77":                   "Transporte - Coche",
  "commerce-sector-78":                   "Transporte - Metro",
  "commerce-sector-79":                   "Transporte - Taxi",
  "commerce-sector-80":                   "Transporte - Tren",
  "commerce-sector-81":                   "Transportes",
  "commerce-sector-86":                   "Tributos",
  "commerce-sector-87":                   "Viajes",
  "commerce-sector-9":                    "Arte",
  "commerce-sector-others":               "Otros"
}